/**
 * 状态管理器 - 配置项
 *
 * @ version 1.0.0
 **/
import {
  setStore
} from '../../utils/storage.js'
import {
  filterArray
} from '../../utils/utils.js'
export default {
  namespaced: true,
  state: {
    navSelect: {
      navIndex: -1,
      navSubIndex: -1
    },
    category: null, //类别
    dict: null,
    serv: null
  },
  mutations: {
    // 记录菜单选择
    recordNav(state, {
      navIndex,
      navSubIndex
    }) {
      state.navSelect.navIndex = navIndex
      state.navSelect.navSubIndex = navSubIndex
    },
    resetNav(state){
      state.navSelect.navIndex = 0
      state.navSelect.navSubIndex = 0
    },
    // 认证服务范围类别
    recordServCata(state, payload) {
      // console.log("state",state);
      // console.log("payload",payload);
      var tempList = []
      var tempMap = new Map()
      payload.forEach((item, i) => {
        var tempParent = {}
        tempParent.servId = item.servId
        tempParent.servCode = item.servCode
        tempParent.servName = item.servName
        tempParent.servType = item.servType
        tempParent.sort = item.sort
        var tempChildList = []
        item.children.forEach((itemChild, i) => {
          var tempChild = {}
          tempChild.servId = itemChild.servId
          tempChild.servCode = itemChild.servCode
          tempChild.servName = itemChild.servName
          tempChild.servType = itemChild.servType
          tempChild.sort = itemChild.sort
          tempChild.isCln = itemChild.isCln
          tempChild.clnBprice = itemChild.clnBprice
          tempChild.clnSprice = itemChild.clnSprice

          tempChild.clnBpricePri = itemChild.clnBpricePri
          tempChild.clnSpricePri = itemChild.clnSpricePri
          tempChild.clnBpriceMid = itemChild.clnBpriceMid
          tempChild.clnSpriceMid = itemChild.clnSpriceMid

          tempChild.isFty = itemChild.isFty
          tempChild.ftyBprice = itemChild.ftyBprice
          tempChild.ftySprice = itemChild.ftySprice
          tempChild.ftyBpricePri = itemChild.ftyBpricePri
          tempChild.ftySpricePri = itemChild.ftySpricePri
          tempChild.ftyBpriceMid = itemChild.ftyBpriceMid
          tempChild.ftySpriceMid = itemChild.ftySpriceMid
          tempChild.ftyBpriceSen = itemChild.ftyBpriceSen
          tempChild.ftySpriceSen = itemChild.ftySpriceSen
          tempChild.editScanModelBprice = itemChild.editScanModelBprice
          tempChild.editScanModelSprice = itemChild.editScanModelSprice

          tempChild.steelTeeth = itemChild.steelTeeth
          tempChild.rubberFilledTeeth = itemChild.rubberFilledTeeth
          tempChild.precisionAccessories = itemChild.precisionAccessories
          tempChild.totalDentureDesign = itemChild.totalDentureDesign

          tempChild.rushFee = itemChild.rushFee
          tempChild.timeAdd = itemChild.timeAdd
          tempChild.timeLimit = itemChild.timeLimit
          tempChild.remark = itemChild.remark
          tempChild.isTooth = itemChild.isTooth
          tempChild.isHole = itemChild.isHole
          tempChild.isDataType = itemChild.isDataType
          tempChild.isSoftType = itemChild.isSoftType
          tempChild.isScanData = itemChild.isScanData
          tempChild.isSheetData = itemChild.isSheetData
          tempChild.isMouthData = itemChild.isMouthData
          tempChild.isCbctData = itemChild.isCbctData
          tempChild.isParam = itemChild.isParam
          tempChild.isDeviceType = itemChild.isDeviceType
          tempChild.isImpSystem = itemChild.isImpSystem
          tempChild.isPlate = itemChild.isPlate
          tempChild.isAbutPath = itemChild.isAbutPath
          tempChild.isBriCraft = itemChild.isBriCraft
          tempChild.isMinThick = itemChild.isMinThick
          tempChild.isDiapThick = itemChild.isDiapThick
          tempChild.isCollar = itemChild.isCollar
          tempChild.isDesignData = itemChild.isDesignData
          tempChild.isDesignReport = itemChild.isDesignReport
          tempChild.isDesignGuide = itemChild.isDesignGuide
          tempChildList.push(tempChild)
          tempMap.set(tempChild.servId, tempChild)
        })
        tempParent.children = tempChildList
        tempList.push(tempParent);
      })
      state.serv = tempMap
      state.category = tempList
      // console.log("state.category", state.category);
      // console.log("state.serv", state.serv);
      // setStore('category', tempList)
    },
    // 认证服务范围类别
    recordImplDict(state, payload) {
      var tempList = []
      var tempMap = new Map()
      payload.forEach((item, i) => {
        var tempParent = {}
        tempParent.implId = item.implId
        tempParent.implName = item.implName
        tempParent.sort = item.sort
        tempMap.set(tempParent.implId, tempParent)
        var tempChildList = []
        item.children.forEach((itemChild, i) => {
          var tempChild = {}
          tempChild.implId = itemChild.implId
          tempChild.implName = itemChild.implName
          tempChild.sort = itemChild.sort
          tempChildList.push(tempChild)
          tempMap.set(tempChild.implId, tempChild)
        })
        tempParent.children = tempChildList
        tempList.push(tempParent);
      })
      state.implDict = tempMap
      state.implList= tempList
      // console.log("state.implDict: ",state.implDict);
      // console.log("state.implList: ",state.implList);
    },
    //记录字典
    recordDict(state, dictList) {
      var tempMap = new Map();
      dictList.forEach((item, i) => {
        tempMap.set(item.dictType, item.children)
      })
      state.dict = tempMap
      // console.log("state.dict",state.dict);
      setStore('dict', tempMap)
    }
  },
  actions: {
    async getServ({
      state,
      dispatch
    }, data) {
      return new Promise((resolve, reject) => {
        var service = filterArray(data.servId, state.category)
        if (service != false) {
          resolve(service)
        } else {
          resolve(false);
        }
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js